import useSWR from "swr"
import { swrFetcher } from "./helpers"
import { AppointmentAvailability } from "./aboboApiTypes"

type AppointmentSlotParams = {
  startDate: string,
  endDate?: string,
  serviceId: string,
  language: string,
  operatorIds?: string[],
}


export const useAppointmentAvailabilities = (params: AppointmentSlotParams) => {
  const { data: response, error } = useSWR(
    ['/availabilities', { method: 'POST', body: params }], 
    swrFetcher<AppointmentAvailability[]>, 
    {revalidateOnFocus: false}
  )

  return {
    appointmentAvailabilities: response?.data,
    isLoading: !error && !response,
    isError: error,
  }
}
